import React, { useRef, useState } from 'react';
import bemCn from 'bem-cn';
import { IMG_RESIZES } from '../../consts/resizer.consts';
import { ImageHelper } from '../../classes/image-helper.class';
import PictureSet from '../picture-set';
import SvgChevronRight from 'src/assets/svg/SvgChevronRight.svg';
import Img1 from '../../assets/img/as-seen/p-fortune.png';
import Img2 from '../../assets/img/as-seen/p-gma.png?sizes[]=300';
import Img3 from '../../assets/img/as-seen/p-insider.png';
import Img4 from '../../assets/img/as-seen/p-money.png';
import Img5 from '../../assets/img/as-seen/p-nytimes.png';
import Img6 from '../../assets/img/as-seen/p-today.png';
import './style.scss';

const b = bemCn('sniff-as-seen');

const imgs = [
    { img: Img1, alt: 'Fortune' },
    { img: Img2, alt: 'Good Morning America' },
    { img: Img3, alt: 'Business Insider' },
    { img: Img4, alt: 'Money' },
    { img: Img5, alt: 'NYTimes' },
    { img: Img6, alt: 'Today Show' },
];

const ArrowBtn = ({ index, length, next, prev }) => {
    return (
        <>
            <button className={b('arrows prev')} style={{ visibility: index == 0 ? 'hidden' : 'visible' }} onClick={prev}>
                <SvgChevronRight />
            </button>
            <button className={b('arrows next')} style={{ visibility: index == length - 1 ? 'hidden' : 'visible' }} onClick={next}>
                <SvgChevronRight />
            </button>
        </>
    );
};

const SniffAsSeen = () => {
    const [index, setIndex] = useState(0);
    const [imgUrlMb, setimgUrlMb] = useState(ImageHelper.getUrlFromOptions(imgs[index].img, `fit-in/${IMG_RESIZES.x354}`));
    const [mouseDownX, setMouseDownX] = useState(null);
    const [isFading, setIsFading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [touchStartX, setTouchStartX] = useState(null);

    const prevImgUrlRef = useRef(imgUrlMb);

    const length = imgs.length;

    const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);

    const handleMouseDown = (e) => {
        e.preventDefault();
        setMouseDownX(e.clientX);
    };

    const goTo = (newIdx) => {
        const newImgUrl = ImageHelper.getUrlFromOptions(imgs[newIdx].img, `fit-in/${IMG_RESIZES.x354}`);
        setimgUrlMb(newImgUrl);

        if (newImgUrl === prevImgUrlRef.current) {
            setIndex(newIdx);
            return;
        }

        setIsFading(true);
        setIsLoading(true);
        setTimeout(() => {
            setIndex(newIdx);
            prevImgUrlRef.current = newImgUrl;
        }, 100);
    };

    const prev = (e) => {
        e?.preventDefault();
        if (index > 0) {
            goTo(index - 1);
        } else {
            goTo(length - 1);
        }
    };

    const next = (e) => {
        e?.preventDefault();
        if (index < length - 1) {
            goTo(index + 1);
        } else {
            goTo(0);
        }
    };

    const handleMouseUp = (e) => {
        e.preventDefault();
        if (mouseDownX === null) {
            return;
        }
        const deltaX = mouseDownX - e.clientX;
        if (deltaX > 50) {
            next();
        } else if (deltaX < -50) {
            prev();
        }
        setMouseDownX(null);
    };

    const handleTouchEnd = (e) => {
        if (touchStartX === null) {
            return;
        }
        const deltaX = touchStartX - e.changedTouches[0].clientX;
        if (deltaX > 50) {
            next();
        }
        if (deltaX < -50) {
            prev();
        }
        setTouchStartX(null);
    };

    return (
        <div className={b()}>
            <p className="snif-p text-italic text-center">As seen on</p>
            <div className={b('carousel-inhouse')}>
                <div
                    className={`carousel-image ${isFading ? 'fade-out' : isLoading ? '' : 'fade-in'}`}
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseUp}
                >
                    <PictureSet
                        imgs={imgUrlMb}
                        alt={imgs[index].alt}
                        method="lazy"
                        onLoad={() => {
                            setIsLoading(false);
                            setIsFading(false);
                        }}
                        draggable={false}
                        noLoad
                    />
                    <div className={b('dotted')}>
                        {imgs.map((_, idx) => (
                            <div key={idx} className={b('dotted-item', { active: idx == index })} />
                        ))}
                    </div>
                </div>
            </div>
            <ArrowBtn {...{ index, length, next, prev }} />
        </div>
    );
};

export default SniffAsSeen;
